var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTemplate = function SvgTemplate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 10,
    "data-width-16": 13,
    "data-width-20": 16,
    "data-width-24": 19,
    "data-width-28": 22,
    "data-width-72": 56,
    viewBox: "0 0 21.6 20.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.292 20.417H2.625A2.625 2.625 0 0 1 0 17.792V2.625A2.625 2.625 0 0 1 2.625 0h4.667a2.625 2.625 0 0 1 2.625 2.625v15.167a2.625 2.625 0 0 1-2.625 2.625M2.625 1.75a.887.887 0 0 0-.875.875v15.167a.886.886 0 0 0 .875.875h4.667a.887.887 0 0 0 .875-.875V2.625a.887.887 0 0 0-.875-.875zm16.333 18.667h-4.666a2.625 2.625 0 0 1-2.625-2.625v-1.75a2.625 2.625 0 0 1 2.625-2.625h4.666a2.625 2.625 0 0 1 2.625 2.625v1.75a2.625 2.625 0 0 1-2.625 2.625m-4.666-5.25a.886.886 0 0 0-.875.875v1.75a.886.886 0 0 0 .875.875h4.666a.887.887 0 0 0 .875-.875v-1.75a.886.886 0 0 0-.875-.875zm0-3.5h4.666a2.625 2.625 0 0 0 2.625-2.625V2.625A2.625 2.625 0 0 0 18.958 0h-4.666a2.625 2.625 0 0 0-2.625 2.625v6.417a2.625 2.625 0 0 0 2.625 2.625m-.616-9.657a.89.89 0 0 1 .616-.26h4.666a.887.887 0 0 1 .875.875v6.417a.886.886 0 0 1-.875.875h-4.666a.886.886 0 0 1-.875-.875V2.625a.89.89 0 0 1 .26-.615",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTemplate);
export default ForwardRef;